import React from 'react';
import { ErrorContentLayout } from 'layout';
// TODO improve
export const DossierUnknownScene = () => {
    return (React.createElement(ErrorContentLayout, null, "Unknown step"));
};
